import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgOverwhelmedSelectedEmojiSecondary from './svgs/OverwhelmedSelectedEmojiSecondary.js';
import SvgOverwhelmedSelectedEmoji from './svgs/OverwhelmedSelectedEmoji.js';
import { useIcon } from '../../shared-components/icon/index.js';

var overwhelmedSelectedEmoji = (props => useIcon(SvgOverwhelmedSelectedEmoji, SvgOverwhelmedSelectedEmojiSecondary, props));

export { overwhelmedSelectedEmoji as default };
